export const environment = {
  production: false,
  isLocal: false,
  mainapiUrl: 'https://stakeholders-api.dev.beaconconnect.app/v1/core',
  messagingUrl: 'https://messaging-api.dev.beaconconnect.app/v1/messaging',
  dispatchUrl: 'https://dispatch-api.dev.beaconconnect.app/v1/dispatch',
  enviromentType: 'dev',
  mapId: '6a2150d7d0e6b1dc',
  firebase: {
    storageBucket: 'ce-dev-cloudstg-us-east4',
  },
};
